<app-term-form
  (outputTermData)="submitTermUpdate($event)"
  [loadingStatus]="termDataLoadingStatus$ | async"
></app-term-form>
